import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { setCookiesAccepted, setShowCookieBanner } from 'core/layout/reducer';
import { removeGACookies, clarityConcentV2 } from 'core/utils';
import { RoutePaths } from 'core/models';
import { useAppDispatch } from './use-app-dispatch';

const useUptimeCookies = () => {
  const dispatch = useAppDispatch();
  const storeCookiesInLocalStorage = useCallback((storageKey: string, acceptedCookies: boolean) => {
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        acceptedCookies,
        showCookieBanner: false,
        consentDate: DateTime.local().toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS),
      })
    );
  }, []);

  const onAcceptAllHandler = useCallback(() => {
    storeCookiesInLocalStorage('userCookiesConsent', true);
    clarityConcentV2('denied', 'granted');
    dispatch(setCookiesAccepted(true));
    dispatch(setShowCookieBanner(false));
  }, [dispatch, storeCookiesInLocalStorage]);

  const onRejectAllHandler = useCallback(() => {
    storeCookiesInLocalStorage('userCookiesConsent', false);
    clarityConcentV2('denied', 'denied');
    dispatch(setCookiesAccepted(false));
    dispatch(setShowCookieBanner(false));
    removeGACookies();
  }, [dispatch, storeCookiesInLocalStorage]);

  const onModifyCookiesHandler = useCallback(() => {
    window.location.href = RoutePaths.UserInfo;
    dispatch(setShowCookieBanner(false));
  }, [dispatch]);

  const onToggleChangeHandler = useCallback(() => {
    const getLocalStorage = localStorage.getItem('userCookiesConsent');
    if (getLocalStorage) {
      const parsedLocalStorage = JSON.parse(getLocalStorage);
      storeCookiesInLocalStorage('userCookiesConsent', !parsedLocalStorage.acceptedCookies);
      if (!parsedLocalStorage.acceptedCookies) {
        clarityConcentV2('denied', 'granted');
      } else {
        clarityConcentV2('denied', 'denied');
      }
      dispatch(setCookiesAccepted(!parsedLocalStorage.acceptedCookies));
      dispatch(setShowCookieBanner(false));

      if (parsedLocalStorage.acceptedCookies) {
        removeGACookies();
      }

    } else {
      localStorage.setItem(
        'userCookiesConsent',
        JSON.stringify({
          acceptedCookies: true,
          showCookieBanner: false,
          consentDate: DateTime.local().toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS),
        })
      );
    }
  }, [dispatch, storeCookiesInLocalStorage]);

  return {
    onAcceptAllHandler,
    onRejectAllHandler,
    onModifyCookiesHandler,
    onToggleChangeHandler,
  };
};

export default useUptimeCookies;
